import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CustomerDetails {
  name: string;
  email: string;
}

interface StripeState {
  selectedStripeCustomerId: string | null;
  selectedEmployeeStripeCustomerId: string | null;
  isAutopay: boolean | true;
  employerCustomerDetails: CustomerDetails | null;
  employeeCustomerDetails: CustomerDetails | null;
}

const initialState: StripeState = {
  selectedStripeCustomerId: null,
  selectedEmployeeStripeCustomerId: null,
  isAutopay: true,
  employerCustomerDetails: null,
  employeeCustomerDetails: null,
};

const stripeSlice = createSlice({
  name: "stripe",
  initialState,
  reducers: {
    setStripeCustomerId: (state, action: PayloadAction<string>) => {
      state.selectedStripeCustomerId = action?.payload;
    },
    setEmployeeStripeCustomerId: (state, action: PayloadAction<string>) => {
      state.selectedEmployeeStripeCustomerId = action?.payload;
    },
    setIsAutopay: (state, action: PayloadAction<boolean>) => {
      state.isAutopay = action.payload;
    },
    setEmployerCustomerDetails: (
      state,
      action: PayloadAction<CustomerDetails>,
    ) => {
      state.employerCustomerDetails = action.payload;
    },
    setEmployeeCustomerDetails: (
      state,
      action: PayloadAction<CustomerDetails>,
    ) => {
      state.employeeCustomerDetails = action.payload;
    },
  },
});

export const {
  setStripeCustomerId,
  setEmployeeStripeCustomerId,
  setIsAutopay,
  setEmployerCustomerDetails,
  setEmployeeCustomerDetails,
} = stripeSlice.actions;
export default stripeSlice.reducer;
